import React, { useEffect, useState } from "react";
import goToScreen from "../lib/goToScreen";
import AccountsComponent from "../Components/Accounts";
import Loader from "../Components/Loader";
import refreshPage from "../lib/refreshPage";
import isSiteBuilder from "../lib/isSiteBuilder";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function getAllAccounts(history, setAllAccounts, setLoading) {
  if (isSiteBuilder()) {
    setTimeout(() => {
      console.log("placeholder");
    }, 2000);
    return;
  }

  window.OrendaGetResponse(
    { event_name: "page load - accounts" },
    (response) => {
      if (response.error) return refreshPage(); // goToScreen(history, 'accounts');
      console.log(response);
      const { accounts } = response;
      if (accounts.length === 1)
        return goToScreen(history, accounts[0].current_screen);
      // if(accounts.length === 1 && accounts[0].current_screen === "home"){
      //     return goToScreen(null, "");
      // }
      // if(accounts.length === 1 && accounts[0].current_screen === "kyc"){
      //     return goToScreen(history, "kyc");
      // }
      // if(accounts.length === 1 && accounts[0].current_screen === "new_apply"){
      //     return goToScreen(history, "new_apply");
      // }
      setLoading(false);
      return setAllAccounts(accounts);
    },
    false
  );
  return;
}

export default function Accounts({ history }) {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [allAccounts, setAllAccounts] = useState([]);

  useEffect(() => {
    getAllAccounts(history, setAllAccounts, setLoading);
  }, [history]);

  function handleAccountChosen(id, current_screen) {
    if (isSiteBuilder()) {
      setTimeout(() => {
        console.log("placeholder");
        setLoading(true);
      }, 2000);
      return;
    }

    window.OrendaGetResponse(
      { event_name: "account chosen", data: JSON.stringify({ AccountId: id }) },
      (response) => goToScreen(history, current_screen),
      false
    );
    setLoading(true);
    return;
  }

  if (loading) return <Loader />;

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <AccountsComponent
        accounts={allAccounts}
        handleAccountChosen={handleAccountChosen}
        domain={window.location.host}
      />
    </div>
  );
}
